/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { StoreDto } from '../../models/store-dto';
import { UpdateStoreDto } from '../../models/update-store-dto';

export interface StoreControllerUpdate$Params {
  storeId: string;

  /**
   * Store identifier for multi-tenant requests.
   */
  'terrific-store-id'?: string;
  body: UpdateStoreDto;
}

export function storeControllerUpdate(
  http: HttpClient,
  rootUrl: string,
  params: StoreControllerUpdate$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<StoreDto>> {
  const rb = new RequestBuilder(rootUrl, storeControllerUpdate.PATH, 'patch');
  if (params) {
    rb.path('storeId', params.storeId, {});
    rb.header('terrific-store-id', params['terrific-store-id'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<StoreDto>;
    })
  );
}

storeControllerUpdate.PATH = '/api/v1/stores/{storeId}';
